import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Headline, Subheadline } from 'common/components/Typography';
import { colorAppLink, colorAppBorder } from 'common/styles/colors';
import { containerPaddingXs, containerPaddingS, baseBorderWidth } from 'common/styles/variables';

const OptionContainer = styled.div`
    padding: ${containerPaddingS} 0;
    min-height: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &::after {
        content: '';
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        border-bottom: ${baseBorderWidth} solid ${colorAppBorder};
    }
`;

const StyledHeadline = styled(Headline)`
    ${(props) => props.isFeatured && `color: ${colorAppLink};`}
`;

const StyledSubheadline = styled(Subheadline)`
    margin-top: ${containerPaddingXs};
`;

const MultilineDropdownOption = (props) => (
    <OptionContainer>
        <StyledHeadline size="small" isFeatured={props.isFeatured}>
            {props.label}
        </StyledHeadline>
        {props.helperText && <StyledSubheadline size="small">{props.helperText}</StyledSubheadline>}
    </OptionContainer>
);

MultilineDropdownOption.propTypes = {
    label: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    isFeatured: PropTypes.bool,
};

MultilineDropdownOption.defaultProps = {
    helperText: null,
    isFeatured: false,
};

export default MultilineDropdownOption;
